import { useQuery } from "@tanstack/react-query";
import { useAccess, useAccountId } from "../Auth/auth-functions";
import { api } from "./api";
import { AzureADRoles } from "../Auth/auth-roles";
import { EventDto } from "../models/event.models";

export const useGetEventsByUserIdQuery = (userId: string | null) => { 
	const hasAccess = useAccess(AzureADRoles.All);
	const accountId = useAccountId();

	return useQuery({
		queryKey: ['events-user', accountId, userId],
		queryFn: async () => {
			let res = await api.get<EventDto[]>(`/users/${userId}/events`);
			return res.data;
		},
		staleTime: 60 * 1000,
		gcTime: 5 * 60 * 1000,
		enabled: hasAccess && userId !== null
	});
}